<template>
  <div>
    <div class="query_change" style="font-size: 12px">
      <div class="margin_cell">
        <div class="cell_style">选择生产单元：</div>
        <div class="margin_parmas">
          <el-checkbox-group v-model="checkedCell" @change="handleCheckedCellChange">
            <el-checkbox class="margin-bom" v-for="cell in listCell" :label="cell.id" :key="cell.id">{{cell.name}}</el-checkbox>
          </el-checkbox-group></div>
      </div>
      <div class="margin_cell">
        <div class="cell_style">选择环境参数：</div>
        <div class="margin_parmas">
          <el-checkbox-group v-model="checkedparams" @change="handleCheckedParamsChange">
            <el-checkbox class="margin-bom" v-for="params in cell_params_list" :label="params.typeCHN" :key="params.snpid">{{params.typeCHN}}{{params.suffix}}</el-checkbox>
          </el-checkbox-group></div>
      </div>
      <div  class="margin_cell margin_button">
        <div class="cell_style">时间范围选择：</div>
        <el-date-picker
          class="date_pick"
          v-model="his_time"
          type="datetimerange"
          :picker-options="pickerOptions"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['12:00:00', '08:00:00']">
        </el-date-picker>
        <el-button class="margin_left" type="primary" @click="findData()">确定</el-button>
      </div>
    </div>
    <div class="hisQurey" ref="hisQurey" :style="{width: curWidth, height:'500px'}"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      checkedCell: [],
      checkedparams: [],
      cell_params_list: [],
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      listCell: [],
      cell_params_all: [],
      his_time: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      all_data: [],
      his_data_name: [],
      his_data_x: [],
      cell_name: [],
      curWidth: ''
    }
  },
  methods: {
    handleCheckedCellChange (value) {
      // console.log(value)
    },
    handleCheckedParamsChange (value) {
      // console.log(value)
    },
    getAllCell () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = (res.data.data.list)
      }).catch(err => {
        console.log(err)
      })
    },
    getAllParams () {
      this.cell_params_all = []
      this.cell_params_list = []
      for (let i = 0; i < this.checkedCell.length; i++) {
        this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
          {
            params: {'cell_id': this.checkedCell[i]},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          let k
          for (let j = 0; j < res.data.data.length; j++) {
            this.cell_params_all.push(res.data.data[j])
            for (k = 0; k < this.cell_params_list.length; k++) {
              if (res.data.data[j].typeCHN === this.cell_params_list[k].typeCHN) {
                break
              }
            }
            if (this.cell_params_list.length === k) {
              this.cell_params_list.push(res.data.data[j])
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time * 1000)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    findData () {
      this.his_data_name = []
      this.his_data_x = []
      this.cell_name = []
      for (let i = 0; i < this.checkedCell.length; i++) {
        for (let j = 0; j < this.listCell.length; j++) {
          if (this.checkedCell[i] === this.listCell[j].id) {
            this.cell_name[i] = this.listCell[j].name
          }
        }
      }
      var series = []
      const color1 = ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531']
      let num = 0
      var m = this.his_time[0]
      this.his_data_x.push(this.his_time[0])
      for (let i = this.resetTime(new Date(m).getTime() + 1000 * 60 * 5); i <= this.his_time[1]; i = this.resetTime(new Date(i).getTime() + 1000 * 60 * 5)) {
        this.his_data_x.push(i)
      }
      for (let i = 0; i < this.checkedCell.length; i++) {
        for (let j = 0; j < this.checkedparams.length; j++) {
          for (let k = 0; k < this.cell_params_all.length; k++) {
            if (this.checkedparams[j] === this.cell_params_all[k].typeCHN) {
              this.axios.get(this.$store.state.ip + 'opt/hisAggrQuery',
                {
                  params: {'cell_ids': this.checkedCell[i], 'snp_types': this.cell_params_all[k].type, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
                  headers: {'Authorization': 'Bearer ' + this.token}
                }).then(res => {
                for (let t = 0; t < res.data.data[0].sntvs.length; t++) {
                  this.all_data = res.data.data[0].sntvs
                }
                this.his_data_x = this.all_data[0].times
                for (let t = 0; t < this.all_data.length - 1; t++) {
                  for (let f = t + 1; f < this.all_data.length; f++) {
                    if (this.all_data[t].times.length < this.all_data[f].times.length) {
                      this.his_data_x = this.all_data[f].times
                    }
                  }
                }
                for (let t = 0; t < this.his_data_x.length; t++) {
                  this.his_data_x[t] = this.resetTime(this.his_data_x[t])
                }
                for (let t = 0; t < this.all_data.length; t++) {
                  if (num === 6) {
                    num = 0
                  }
                  if (this.all_data[t].snpid === this.cell_params_all[k].snpid) {
                    this.his_data_name.push(this.cell_name[i] + ' ' + this.cell_params_all[k].name + ' ' + this.cell_params_all[k].typeCHN)
                    var test = []
                    for (let f = 0; f < this.all_data[t].times.length; f++) {
                      test = test.concat({'time': this.resetTime(this.all_data[t].times[f]), 'value': this.all_data[t].values[f]})
                    }
                    series.push({
                      name: this.cell_name[i] + ' ' + this.cell_params_all[k].name + ' ' + this.cell_params_all[k].typeCHN,
                      type: 'line',
                      itemStyle: {
                        normal: {
                          lineStyle: { // 折线样式
                            width: 2.5,
                            type: 'solid',
                            color: color1[num] // 拆线颜色
                          }
                        },
                        emphasis: {
                          color: color1[num],
                          lineStyle: {
                            type: 'dotted',
                            color: color1[num++]
                          }
                        }
                      },
                      symbolSize: 5,
                      data: test
                    })
                    break
                  }
                }
                if (i === this.checkedCell.length - 1) {
                  let mycharts = this.$echarts.init(this.$refs.hisQurey)
                  mycharts.setOption({
                    tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                        type: 'cross',
                        label: {
                          backgroundColor: '#6a7985'
                        }
                      }
                    },
                    color: ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531'],
                    legend: {
                      left: 20,
                      data: this.his_data_name
                    },
                    dataZoom: [
                      {
                        show: true,
                        realtime: true,
                        start: 0
                        // end: 25 / this.his_data_x[0].length * 100
                      },
                      {
                        type: 'inside',
                        realtime: true,
                        start: 0,
                        end: 100
                      }
                    ],
                    toolbox: {
                      feature: {
                      }
                    },
                    grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                    },
                    xAxis: [
                      {
                        type: 'category',
                        boundaryGap: false,
                        data: this.his_data_x
                      }
                    ],
                    yAxis: [
                      {
                        type: 'value',
                        axisTick: {
                          show: false
                        }
                      }
                    ],
                    series: series
                  }, true)
                }
              }).catch(err => {
                console.log(err)
              })
            }
          }
        }
      }
    }
  },
  created () {
    this.getAllCell()
    this.curWidth = document.body.clientWidth - 260 + 'px'
  },
  watch: {
    'checkedCell': function () {
      this.getAllParams()
    }
  }
}
</script>

<style scoped>
.margin_cell {
  display: flex;
  align-items: left;
  justify-content: left;
  padding-top: 8px;
  padding-left: 10px;
}
.margin_parmas {
  display: flex;
  float: left;
  width: 88%;
  text-align: left;
}
.cell_style{
  font-size: 14px;
  font-weight: bold;
  width: 120px;
}
.margin-bom {
  margin-bottom: 10px;
}
.margin_button {
  display: flex;
  align-items: center;
  justify-content: left;
  padding-top: 8px;
  padding-left: 10px;
}
.date_pick {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.margin_left {
  margin-left: 20px;
}
.query_change {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: white;
  min-height: 110px;
  padding-bottom: 10px;
}
.hisQurey{
  margin: 0 auto;
  margin-top: 30px;
  padding-top: 20px;
  padding-bottom: 15px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/userData/analysisData.vue